var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55032 0.951056C8.84834 0.0269725 10.1558 0.0269706 10.4538 0.951054L11.971 5.65552C12.1045 6.06937 12.4901 6.34953 12.9249 6.34858L17.868 6.33778C18.8389 6.33566 19.2429 7.57908 18.4562 8.14808L14.4508 11.0448C14.0985 11.2996 13.9512 11.7529 14.0864 12.1662L15.6242 16.864C15.9263 17.7867 14.8685 18.5552 14.0843 17.9828L10.0916 15.0686C9.74037 14.8122 9.26373 14.8122 8.9125 15.0686L4.91983 17.9828C4.13556 18.5552 3.07784 17.7868 3.3799 16.864L4.91766 12.1662C5.05294 11.7529 4.90565 11.2996 4.5533 11.0448L0.547931 8.14808C-0.23883 7.57908 0.165182 6.33566 1.13613 6.33778L6.07919 6.34858C6.51403 6.34953 6.89964 6.06937 7.03311 5.65552L8.55032 0.951056Z",
    fill: "#FEBA65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.fc5183a6f62105b7ac070e9097b3bb01.svg";
export { ForwardRef as ReactComponent };